import React from 'react';
import { CodeBlockProps, PropInfo } from '@cimpress/react-components';
import CodeBlockDemo from './codeBlock.jsx';
import ComponentDoc from '../../shared/TabbedComponentDoc';

const CodeBlockDocs = () => {
  const propInfos: PropInfo<CodeBlockProps>[] = [
    {
      name: 'code',
      type: 'string',
      default: '',
      description: <span>The code to render</span>,
    },
  ];

  return (
    <ComponentDoc<CodeBlockProps> name="CodeBlock" propInfos={propInfos}>
      <CodeBlockDemo />
    </ComponentDoc>
  );
};

export default CodeBlockDocs;
